// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__vzHa0","total":"Cart_total__2eGro","actions":"Cart_actions__1WjU2","btn":"Cart_btn__2sslU","btn2":"Cart_btn2__iINFe"};